import React, {  useState } from 'react';
import View from "./view";
import Toolbar from "./toolbar"
import LayoutHeaderAuctions from "../auctionsRoom/header/Appbar";
import Page from 'src/components/Page';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';


function Index(props) {
 




  return (
    <React.Fragment>
            <Page title="Profile">
      <CssBaseline />
      <Container fixed>
    
      <div style={{marginTop:50}}> 
<Toolbar/>
</div>
<div style={{marginTop:50,marginBottom: 150}}> 

      <View />
      </div>
      </Container>
      </Page>
    </React.Fragment>
  );
}


   


export default Index;